import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';
import { Scrollspy, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationIngredientsGridContainer = (
  props: CustomizationIngredientsGridSectionProps,
) => {
  const { children, ...restProps } = props;

  return (
    <View style={styles.outerContainer}>
      <Scrollspy.ScrollView
        contentContainerStyle={styles.contentContainer}
        {...restProps}
      >
        {children}
      </Scrollspy.ScrollView>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    backgroundColor: theme.colors.OATMEAL,
  },
  contentContainer: {
    maxWidth: 1040,
    paddingBottom: theme.spacing['10'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationIngredientsGridSectionProps = ComponentProps<
  typeof Scrollspy.ScrollView
>;
